import a1 from "../assets/01.jpg";
import a2 from "../assets/02.jpg";

export default function HeroSec() {
  return (
    <section class="bg-[#1c70b7] h-screen md:h-auto lg:h-auto">
      <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
        <a
          href="#"
          class="inline-flex justify-between items-center py-1 px-4 pr-4 mb-7 text-sm  rounded-full bg-gray-800 text-white hover:bg-gray-700"
          role="alert"
        ></a>
        <h1 class="mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl text-white">
          Welcome to Speak schedule — Your voice activated google calendar!
        </h1>
        <p class="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48 text-gray-200">
          Download the SPEAK Schedule for scheduling and reminders. Enjoy a
          seamless experience with automatic event scheduling, timely reminders,
          and more.
        </p>
        <div class="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
          <a
            // href="https://play.google.com/store/apps/details?id=com.hrassistancepra&pcampaignid=web_share"
            class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center rounded-lg border focus:ring-4 bg-white text-black border-gray-700 hover:bg-gray-700 hover:text-white focus:ring-gray-800"
          >
            Download App
          </a>
        </div>
        <div className="images flex flex-row gap-x-5 justify-center">
          <div className="w-4/12">
            <img className="rounded-2xl" src={a1} alt="app image 1" />
          </div>

          <div className="w-4/12">
            <img className="rounded-2xl" src={a2} alt="app image 1" />
          </div>
        </div>
      </div>
    </section>
  );
}
